
<template>
  <!--推送详情-->
  <div class="advanced-form">
    <a-form layout="vertical">
      <div class="card">
        <div class="card-head">
          <h3>基本信息</h3>
        </div>
        <div class="card-body">
          <a-row type="flex">
            <a-col v-for="(item, index) of baseInfo" :key="index" v-bind="$store.state.advanced_colWidth">
              <a-form-item class="value-indent narrow-row" :label="item.label">
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </a-col>
          </a-row>
        </div>
      </div>
    </a-form>

    <div class="card">
      <div class="card-head">
        <h3>发送内容</h3>
      </div>
      <div class="card-body">
        <template v-for="(item, index) of pushContent">
        <a-form-item class="label-left" :key="index" :label="item.label" v-bind="{labelCol: { span: 2 }, wrapperCol: { span: 15 }}">
          <span v-if="item.key !== 'scope'" class="ant-form-text">{{item.value}}</span>
          <p v-else-if="item.key === 'scope'&& Array.isArray(item.value)" v-for="(part, i) of item.value" :key="i">{{part}}</p>
          <p v-else>{{item.value}}</p>
        </a-form-item>
        </template>
      </div>
    </div>

    <!--<div class="card">-->
      <!--<div class="card-head">-->
        <!--<h3>推送数据</h3>-->
      <!--</div>-->
      <!--<div class="card-body">-->
        <!--<a-row type="flex">-->
          <!--<a-col v-for="(item, index) of pushData" :key="index" :span="9">-->
            <!--<a-form-item class="form-item-push" :label="item.label" :class="[{'long': index<2}, {'short': index>1}]" :colon="index > 1">-->
              <!--<span class="ant-form-text">{{item.value}}</span>-->
            <!--</a-form-item>-->
          <!--</a-col>-->
        <!--</a-row>-->
      <!--</div>-->
    <!--</div>-->
  </div>
</template>

<script>
export default {
  name: 'pushDetail',
  data () {
    return {
      baseInfo: [
        {key: 'push_id', label: 'ID', value: ''},
        {key: 'push_os', label: '推送平台', value: ''},
        {key: 'push_app_desc', label: '应用', value: ''},
        {key: 'status_title', label: '推送结果', value: ''},
        {key: 'send_time', label: '推送时间', value: ''}
      ],
      pushContent: [
        {key: 'title', label: '标题', value: ''},
        {key: 'content', label: '内容', value: ''},
        {key: 'open_type_desc', label: '后续动作', value: ''},
        {key: 'scope', label: '用户范围', value: ''}
      ],
      dynamicList: [
        {key: 'intent_desc', label: '指定页面', value: ''},
        {key: 'intent_desc', label: 'URL类型', value: ''},
        {key: 'url', label: 'URL', value: ''}
      ],
      pushData: [
        {key: '', label: 'iOS', value: ''},
        {key: '', label: 'Android', value: ''},
        {key: 'ios_total', label: '目标', value: ''},
        {key: 'android_total', label: '目标', value: ''},
        {key: 'ios_success', label: '送达', value: ''},
        {key: 'android_success', label: '送达', value: ''},
        {key: 'ios_click', label: '点击', value: ''},
        {key: 'android_click', label: '点击', value: ''}
      ]
    };
  },
  mounted () {
    if (this.$route.query.id) {
      this.getDetail();
    }
  },
  methods: {
    /* 获取详情 */
    getDetail () {
      this.$get({
        url: `/push/${this.$route.query.id}`,
        params: {}
      }).then(({data}) => {
        if (data.open_type === 'open_link') {
          this.pushContent.splice(3, 0, ...this.dynamicList.slice(1));
        } else if (data.open_type === 'open_app_page') {
          this.pushContent.splice(3, 0, this.dynamicList[0]);
        }

        this.loopSetVal(data, this.baseInfo);
        this.loopSetVal(data, this.pushContent);
        this.loopSetVal(data, this.pushData);
      });
    },
    loopSetVal (res, arr) {
      for (let item in res) {
        arr.forEach((el) => {
          if (el.key === item) {
            if (el.key === 'scope') {
              if (res[item]) {
                el.value = res[item].split(',');
              } else {
                el.value = res.scope_type;
              }
            } else {
              el.value = res[item];
            }
          }
        });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/marketing/push/pushDetail.vue